export { default as withName } from "./withName";
export { default as getName } from "./getName";
export { default as hasName } from "./hasName";
